type DefaultLayoutProps = React.PropsWithChildren<{}>
export const DefaultLayout = ({ children }:DefaultLayoutProps) => {
    return (
      <div className="default-layout .container">
        <main className="main">{children}</main>
      </div>
    );
};